import {Box, CircularProgress, LinearProgress, LinearProgressProps} from '@mui/material'

const LoadingBackdrop = ({ open = false, displayMBDownloaded = false, displayPercent = false, mbDownloaded = 0}) => {
    if (!open) return null;

    function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
        const val = props.value
        return (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
                <LinearProgress
                    variant="determinate"
                    value={props.value}
                    sx={{ mb: 2, height: 8, borderRadius: 1 }}
                />
                <div
                    style={{
                        marginTop: '20px',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'center',
                    }}
                >
                    {(val && val > 1 && val < 100) &&
                        val  + "% Complete"
                    }
                    {(val && val >= 100) &&
                        'Finalizing Save...'
                    }
                    {(val == null) &&
                        'Starting Save...'
                    }
                </div>
            </Box>
        );
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 999,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {!displayPercent &&
                <CircularProgress color="primary" size={70} />
            }
            {displayMBDownloaded &&
                <div
                    style={{
                        marginTop: '20px',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'center',
                    }}
                >
                    {mbDownloaded
                        ? `${mbDownloaded.toFixed(2)} MB downloaded`
                        : 'Starting download...'}
                </div>
            }
            {displayPercent &&
                <>
                    <Box sx={{ width: '25%' }}>
                        <LinearProgressWithLabel value={mbDownloaded} />
                    </Box>
                </>
            }
        </div>
    )
}

export default LoadingBackdrop
